import ResponseModel from "../../models/response.model";
import axiosSetup from "../../utils/axiosSetup";

export const createFloorInwardRequestApi = async (
  requests: {
    productId: string;
    quantity: number;
    unit: string;
    remark?: string;
  }[],
): Promise<ResponseModel> => {
  try {
    const path = "/factory/floor/inward-request";

    const res = await axiosSetup.post(path, { items: requests });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const approveFloorInwardRequestApi = async (
  id: string,
  data: any,
  remark?: string,
): Promise<ResponseModel> => {
  try {
    const path = `/factory/floor/approve-inward/${id}`;

    const res = await axiosSetup.post(path, { items: data, remark });
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const cancelFloorInwardRequestApi = async (
  id: string,
  remark?: string,
): Promise<ResponseModel> => {
  try {
    const path = `/factory/floor/inward-request-cancel/${id}`;

    const res = await axiosSetup.post(path, { remark });
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const updateFloorRequestItemsApi = async (
  id: string,
  data: any,
): Promise<ResponseModel> => {
  try {
    const path = `/factory/floor/inward-request-update/${id}`;

    const res = await axiosSetup.post(path, { items: data });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getFloorRequestsApi = async (params: {
  page: number;
  limit: number;
  status: string;
  requestedBy?: string;
  warehouseId?: string;
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/floor/all-inward-request";
    const res = await axiosSetup.get(path, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getFloorRequestByIdApi = async (
  id: string,
  materialSearch?: string,
): Promise<ResponseModel> => {
  try {
    const path = `/factory/floor/inward-request/${id}`;
    const res = await axiosSetup.get(path, { params: { materialSearch } });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getFloorBatchesApi = async (params: {
  page: number;
  limit: number;
  status?: string;
  search?: string;
  requestedBy?: string;
  warehouseId?: string;
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/floor/batches";
    const res = await axiosSetup.get(path, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getFloorStocksApi = async (params: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/floor/stock";
    const res = await axiosSetup.get(path, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const outwardProductsApi = async (data: {
  requestId: string;
  units: {
    serialNumber: string;
    loggerSerialNumber: string;
    manufacturingSerialNumber: string;
    productId: string;
  }[];
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/floor/outward-product";
    const res = await axiosSetup.post(path, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const finalizeOutwardProductsApi = async (data: {
  requestId: string;
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/floor/outward-product/finalize";
    const res = await axiosSetup.post(path, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const outwardProductsExcelApi = async (data: {
  batchNo: string | number;
  file: File;
}): Promise<ResponseModel> => {
  try {
    const path = `/factory/floor/outward-product-excel/${data.batchNo}`;
    const formData = new FormData();
    formData.append("file", data.file);

    const res = await axiosSetup.post(path, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const outwardMaterialsApi = async (
  materials: {
    requestId: string;
    materialId: string;
    quantity: number;
    unit: string;
  }[],
): Promise<ResponseModel> => {
  try {
    const path = "/factory/floor/outward-Material";
    const res = await axiosSetup.post(path, materials);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const finalizeOutwardMaterialsApi = async (
  requestId: string,
): Promise<ResponseModel> => {
  try {
    const path = "/factory/floor/outward-material/finalize";
    const res = await axiosSetup.post(path, { requestId });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getRequestOutwardBatchesApi = async (
  requestId: string,
): Promise<ResponseModel> => {
  try {
    const path = `/factory/floor/outward-batches/${requestId}`;
    const res = await axiosSetup.get(path);
    return res.data;
  } catch (error) {
    throw error;
  }
};
